import React from 'react';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useHistory } from 'react-router-dom';
import { PageTitle } from '@cordata/buffet';

import { UncontrolledTable } from '~/components/common';

import { useAdmin } from '~/utils/admin';

const defaultSorted = [{
  id: 'carrier-name',
}];

const columns = [{
  id: 'carrierName',
  Header: 'Name',
  accessor: 'attributes.carrierName',
}];

const InsuranceCarriers = () => {
  const history = useHistory();
  const { org } = useAdmin();

  return (
    <>
      <PageTitle
        action={
          <Button
            outline
            tag={Link}
            to="/admin/insurance-carriers/add"
          >
            <FontAwesomeIcon icon="plus" />
            <span className="d-none d-md-inline ml-2">Add Insurance Carrier</span>
          </Button>
        }
      >
        Insurance Carriers
      </PageTitle>

      {org &&
        <UncontrolledTable
          name="insurance-carriers"
          defaultSorted={defaultSorted}
          endpoint={{
            url: 'admin/insurance-carrier',
            params: {
              'org-uid': org.id,
            },
          }}
          columns={columns}
          getTrProps={(state, rowInfo) => ({
            style: {
              cursor: 'pointer',
            },
            onClick: (e, handleOriginal) => (handleOriginal ? handleOriginal() : history.push(`/admin/insurance-carriers/${rowInfo.original.id}`)),
          })}
        />
      }
    </>
  );
};

export default InsuranceCarriers;
